import { render } from "./settings-tab.vue?vue&type=template&id=0136d36a&scoped=true"
import script from "./settings-tab.vue?vue&type=script&lang=js"
export * from "./settings-tab.vue?vue&type=script&lang=js"

import "./settings-tab.vue?vue&type=style&index=0&id=0136d36a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0136d36a"]])

export default __exports__